// Core imports
import * as React from 'react';
import localeFormating from 'src/translation/localeFormating';

// Components imports

// Models imports
import InvoiceModel from 'src/model/invoice.model';

// Style and misc imports
import './EmailInvoiceApplyCreditCard.scss';

class EmailInvoiceApplyCreditCard extends React.Component<
  IEmailInvoiceApplyCreditCardProps,
  any
> {
  /* 
    statusFlagGetter : Reads the status and assign a css class 
   */
  private statusFlagGetter = (invoice: any) => {
    const flags = { type: '', icon: '' };
    switch (invoice.status) {
      case 'PAST DUE':
        flags.type = 'past-due';
        flags.icon = 'rpds-error';
        break;
      case 'DUE':
        flags.type = 'due';
        flags.icon = 'rpds-alert-bell';
        break;
      default:
      case 'PAID':
        flags.type = 'paid';
        flags.icon = 'rpds-check-circle';
        break;
    }

    return flags;
  };

  public render() {
    const { t, invoice, removeInvoiceFromSelected } = this.props;
    const {
      invoiceNumber,
      invoiceDate,
      remainingAmount,
      dueDate,
      status
    } = invoice;

    const statusIcon = this.statusFlagGetter(invoice);

    return (
      <div className="rp-email-invoice-card">
        <span className="invoice-data-- data-column">{invoiceNumber}</span>
        <span className="invoice-data--invoice-date data-column">
          {localeFormating.formatDate(invoiceDate, 'short')}
        </span>
        <span className="invoice-data--remaining-amount data-column">
          {localeFormating.formatCurrency(remainingAmount)}
        </span>
        <span className="invoice-data--due-date data-column">
          {localeFormating.formatDate(dueDate, 'short')}
        </span>
        <span className="invoice-data--status data-column">
          <i className={`${statusIcon.icon} ${statusIcon.type}`} />
          <span className="value">{status}</span>
        </span>
        {/* <span
          className="invoice-data--clear-invoice"
          onClick={() => {
            removeInvoiceFromSelected(invoice);
          }}
        >
          <i className="rpds-close" />
        </span> */}
      </div>
    );
  }
}

export default EmailInvoiceApplyCreditCard;

interface IEmailInvoiceApplyCreditCardProps {
  removeInvoiceFromSelected(invoice: InvoiceModel): void;
  t: any;
  invoice: InvoiceModel;
}
